import XNum from "./XNum";

export * from "./CircleDivide";
export * from "./CircleEqual";
export * from "./CircleMinus";
export * from "./CircleSlash";
export * from "./Cone";
export * from "./CopyMinus";
export * from "./CopyPlus";
export * from "./OctagonX";
export * from "./Pyramid";
export * from "./Sigma";
export * from "./SquareDivide";
export * from "./SquareEqual";
export * from "./SquareSigma";
export * from "./SquareX";
export * from "./Tangent";
export * from "./Tangent2";
export * from "./Weight";
export * from "./XNum";

export const Maths = {
  XNum,
};
